import script from "./ReporteProduccion.vue?vue&type=script&setup=true&lang=js"
export * from "./ReporteProduccion.vue?vue&type=script&setup=true&lang=js"

import "./ReporteProduccion.vue?vue&type=style&index=0&id=535ae23f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-535ae23f"]])

export default __exports__